import React from 'react';
import Numeral from 'numeral';
import * as formatter from 'lib/formatter';
import Icon from 'components/Icon/Icon.react';
import { yearMonthDayFormatter } from 'lib/DateUtils';
import { getRegion } from 'lib/Constants';
import stylesButton from 'components/Button/Button.scss';
import LinkWithBack from 'components/LinkWithBack/LinkWithBack.react';

import Tooltip from 'rc-tooltip';

import stylesEngine from 'dashboard/Runtime/EngineView.scss';
import stylesBilling from 'dashboard/Billing/Billing.scss';
import styles from './Billing.scss';


const detailsURLs = {
  requests: 'requests',
  database: 'database',
  storage: 'files',
  transfer: 'traffic',
};

export default function AppBillingDetails(props) {
  const { app, stats } = props;

  if (!(app && stats)) { return null; }

  const unit_names = {
    requests: 'Requests',
    storage_db: 'Database',
    storage_s3: 'Storage',
    transfer: 'Transfer',
    background_jobs: 'Jobs',
    db_backup: 'DB Backups',
  };

  const additional_names = {
    initial_equalize: 'App prepaid current billing cycle',
    db_backup_equalize: 'DB backups prepaid current billing cycle',
    db_backup: 'DB backups enabled',
  };

  const renderRequests = (n) => {
    const string = Numeral(n).format('0.0a');
    const number = string.replace(/[^0-9\.]+/ig, '');
    const format = string.replace(/[^a-z]+/ig, '').toUpperCase();
    return (
      <div className={styles.usageValue}>
        <div>
          <span>{number}</span>
          <span className={styles.ext}>{format}</span>
        </div>
      </div>
    );
  };

  return (
    <div>
      {Object.keys(stats).map(r =>
        (<div className={[styles.table].join(' ')} key={`bill-${app.id}-${r}`}>
          <div className={styles.infoBox}>
            <img src={app.icon ? app.icon : '/assets/images/default_app_icon.png'} alt="" width="50" />
            <div className={styles.info}>
              <span className={styles.name}>{app.name}</span>
              <span className={styles.moreInfo}>
                Region: <span>{getRegion[r].value}</span>
                <span className={styles.dot}>·</span>
                Created on <span>{yearMonthDayFormatter(app.createdAt || new Date())}</span>
              </span>
            </div>
            <Tooltip
              placement="left"
              overlay="Included resources: 1M Requests, 40GB File Storage, 1GB Database Storage, 500GB Data Transfer, 1 Scheduled Cloud Job"
              overlayClassName={styles.rcTooltip}
              arrowContent={<div className="rc-tooltip-arrow-inner" />}>
              <div className={styles.priceColumn}>
                <label>Initial Price <Icon name="icon-info" width={16} height={16} fill="#47689f" /></label>
                <div className={styles.usagePrice}>
                  {formatter.price(stats[r].initial.price)}
                </div>
              </div>
            </Tooltip>
          </div>

          <div className={[styles.box, styles.table, styles.appDetails].join(' ')}>
            <div className={styles.tableRow}>
              <div>&nbsp;</div>
              <div>Total</div>
              <div>Included</div>
              <div>Extra</div>
              <div>Price <span className={styles.starRed}>*</span></div>
              <div>Details</div>
            </div>
          </div>

          <div className={styles.usage}>
            {[
              Object.keys(unit_names).map((item) => {
                if (item === 'db_backup') {
                  return null;
                }

                return (
                  <div className={styles.usageRow} key={`bill-${app.id}-${r}-${item}`}>
                    <div className={styles.usageColumn}>
                      <div className={styles.usageTitle}>{unit_names[item]}</div>
                    </div>

                    {
                      ['stats', 'initial', 'payable'].map((t) => {
                        return (
                          <div className={styles.usageColumn} key={`bill-${app.id}-${r}-${item}-${t}`}>
                            {
                              // eslint-disable-next-line no-nested-ternary
                              t !== 'initial' && item !== 'background_jobs'
                                ? (
                                  <div className={styles.usageValue}>
                                    {
                                      item === 'requests'
                                        ?
                                          renderRequests(stats[r][t][item])
                                        :
                                          formatter.number(styles.ext, stats[r][t][item], 1, ['requests', 'background_jobs'].includes(item) ? '' : undefined)
                                    }
                                  </div>
                                )
                                : (
                                  t === 'initial' && item === 'requests'
                                    ?
                                      <Tooltip placement="left" overlay={`+ ${formatter.number(styles.ext, stats[r][t][item] - 1000000, 0, ['requests', 'background_jobs'].includes(item) ? '' : undefined, true)} Bonus requests from referrals.`} arrowContent={<div className="rc-tooltip-arrow-inner" />}>
                                        <div className={styles.usageValue}>
                                          {formatter.number(styles.ext, stats[r][t][item], 0, ['requests', 'background_jobs'].includes(item) ? '' : undefined)}
                                          <span className={styles.bonus}> + {formatter.number(styles.ext, stats[r][t][item] - 1000000, 0, ['requests', 'background_jobs'].includes(item) ? '' : undefined, true)}</span>
                                        </div>
                                      </Tooltip>
                                    :
                                      <div className={styles.usageValue}>
                                        {formatter.number(styles.ext, stats[r][t][item], 0, ['requests', 'background_jobs'].includes(item) ? '' : undefined)}
                                      </div>
                                )
                            }
                          </div>
                        );
                      })
                    }

                    <div className={styles.usageColumn}>
                      <div className={styles.usagePrice}>
                        {formatter.price(stats[r].units[item])}
                      </div>
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={styles.enginesTitle}>
                        {
                          item !== 'background_jobs'
                            ?
                              <LinkWithBack
                                className={stylesButton.tableButton}
                                to={`/products/apps/${app.slug}/metrics/${detailsURLs[unit_names[item].toLowerCase()]}`}>
                                Details
                              </LinkWithBack>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                  );
                }),

              Object.keys(stats[r].additional).filter(i => stats[r].additional[i]).map((i) => {
                return (
                  <div className={styles.usageRow} key={`bill-${app.id}-${r}-${i}`}>
                    <div>
                      <div className={styles.usageTitle}>{additional_names[i] || i}</div>
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={styles.usagePrice}>
                        {formatter.price(stats[r].additional[i])}
                      </div>
                    </div>
                  </div>
                );
              }),

            ]}

            {
              stats[r].engines
                ?
                  <div className={styles.usageRow}>
                    <div className={styles.usageColumn}>
                      <div className={styles.usageTitle}>
                        Engines <span className={stylesEngine.starBlue}>*</span>
                      </div>
                    </div>

                    <div className={styles.usageColumn} />
                    <div className={styles.usageColumn} />
                    <div className={styles.usageColumn} />
                    <div className={styles.usageColumn}>
                      <div className={styles.usagePrice}>
                        {formatter.price(stats[r].engines.total)}
                      </div>
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={styles.enginesTitle}>
                        <LinkWithBack
                          className={stylesButton.tableButton}
                          to={`/products/apps/${app.slug}/metrics/engine`}>
                          Details
                        </LinkWithBack>
                      </div>
                    </div>
                  </div>
                : null
            }

            {
              // TODO
              // lets_encrypt
              //   ?
              //     <div className={styles.usageRow} key={`bill-ssl`}>
              //       <div>
              //         <div className={styles.usageTitle}>Free SSL Certificate by Let's Encrypt</div>
              //       </div>
              //       <div className={styles.usageColumn}>
              //         <div className={styles.usagePrice}>
              //           {formatter.price(0)}
              //         </div>
              //       </div>
              //     </div>
              //   : null
            }


            <div className={styles.totalPriceHolder}>
              <div className={styles.totalPrice}>
                <label>Total Price<span className={stylesBilling.starRed}>*</span></label>
                <div className={styles.usagePrice}>
                  {formatter.price(stats[r].total)}
                </div>
              </div>
            </div>

          </div>
        </div>))}
    </div>
  );
}
